import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import SideNav from './side-nav/SideNav';
import SegmentedTabsLayout from './tabs/SegmentedTabsLayout';
import StickyTabsContainer from '../common/StickyContainer';
// @ts-expect-error svg import
import TAB_BACKGROUND from 'bender-url!pricing-pages-ui/img/tabs/tab-background.svg';
import UIImage from 'UIComponents/image/UIImage';
const StyledTabBackground = styled(UIImage).withConfig({
  displayName: "HeaderLayout__StyledTabBackground",
  componentId: "sc-2hxq7u-0"
})(["position:absolute;top:0;height:100% !important;width:100%;max-height:100%;"]);
const StyledFlexContainer = styled(UIFlex).withConfig({
  displayName: "HeaderLayout__StyledFlexContainer",
  componentId: "sc-2hxq7u-1"
})(["top:-1px;max-width:1330px;margin:auto;margin-top:20px;"]);

const HeaderLayout = ({
  selectedNavItem,
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StickyTabsContainer, {
      children: [/*#__PURE__*/_jsx(StyledTabBackground, {
        src: TAB_BACKGROUND,
        "aria-hidden": true
      }), /*#__PURE__*/_jsx(SegmentedTabsLayout, {
        selectedNavItem: selectedNavItem
      })]
    }), /*#__PURE__*/_jsxs(StyledFlexContainer, {
      children: [/*#__PURE__*/_jsx(SideNav, {
        selectedNavItem: selectedNavItem
      }), children]
    })]
  });
};

export default HeaderLayout;